// extracted by mini-css-extract-plugin
export var avatarContainer = "_6d-0";
export var avatarTypingWave = "_6d-i";
export var gray = "_6d-f";
export var green = "_6d-c";
export var icon = "_6d-9";
export var image = "_6d-1";
export var lg = "_6d-6";
export var md = "_6d-5";
export var presenceDot = "_6d-b";
export var red = "_6d-d";
export var sm = "_6d-4";
export var status = "_6d-a";
export var typingDot = "_6d-h";
export var typingPill = "_6d-g";
export var xl = "_6d-7";
export var xs = "_6d-3";
export var xxl = "_6d-8";
export var xxs = "_6d-2";
export var yellow = "_6d-e";